module.exports = __webpack_public_path__ + "img/c07_buildingtechburningpitch_Normal_ua.4d237a59.webp";